import { render, staticRenderFns } from "./PaymentHistory.vue?vue&type=template&id=1baf28f8&scoped=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=js"
export * from "./PaymentHistory.vue?vue&type=script&lang=js"
import style0 from "./PaymentHistory.vue?vue&type=style&index=0&id=1baf28f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baf28f8",
  null
  
)

export default component.exports